import { render } from "./UnitDetails.vue?vue&type=template&id=557c406a&scoped=true"
import script from "./UnitDetails.vue?vue&type=script&lang=js"
export * from "./UnitDetails.vue?vue&type=script&lang=js"

import "./UnitDetails.vue?vue&type=style&index=0&id=557c406a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557c406a"]])

export default __exports__